import {
	SET_RENTABLES,
	SET_RENTABLE,
	CLEAR_RENTABLES,
	CLEAR_RENTABLE,
	ADD_RENTABLE,
	UPDATE_RENTABLE,
	REMOVE_RENTABLE,
} from './actionTypes';

export const rentable = (state = {}, action) => {
	switch (action.type) {
		case SET_RENTABLE:
			return action.payload;
		case UPDATE_RENTABLE:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_RENTABLE:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_RENTABLES:
			return action.payload;
		case ADD_RENTABLE:
			return [...state, action.payload];
		case UPDATE_RENTABLE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_RENTABLE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_RENTABLES:
			return [];
		default:
			return state;
	}
};
